import operatorApiFetch from './apiService';

const workforceStatsService = {
  // 倉庫日報總覽（日期區間）
  getDailySummary: async (from, to) => {
    const response = await operatorApiFetch('workforce_stats/daily_summary', {
      params: { from, to },
    });
    const result = await response.json();
    return result;
  },

  // 全員當日績效
  getOperatorsOverview: async (date, station) => {
    const params = { date };
    if (station) params.station = station;
    const response = await operatorApiFetch('workforce_stats/operators_overview', {
      params,
    });
    const result = await response.json();
    return result;
  },

  // 個人績效（日期區間）
  getOperatorPerformance: async (operatorId, from, to) => {
    const response = await operatorApiFetch('workforce_stats/operator_performance', {
      params: { operator_id: operatorId, from, to },
    });
    const result = await response.json();
    return result;
  },
};

export default workforceStatsService;
